import {useEffect, useRef, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {toLowCaseCleanSpaces} from "core/utils/Texts";

class CreateSelectorData {
    constructor() {
        this.list = [];
        this.result = [];
    }

    add(id, name) {
        if (!id) return;
        if (!this.list.includes(id)) {
            this.list.push(id);
            this.result.push({
                id: id,
                name: name
            })
        }
    }

    get() {
        return [...this.result]
    }
}

const FilterParams = {
    group: "",
    zone: "",
    island: "",
    routes: "",
    searcher: ""
}

const TabCriteriaFilters = ({steps, items, setDynamicAssetsShow, setCheckedAll, setCounter, setActiveMassive}) => {
    const [groups, setGroups] = useState([]);
    const [zones, setZones] = useState([]);
    const [islands, setIslands] = useState([]);
    const [routes, setRoutes] = useState([]);
    const filters = useRef({...FilterParams});

    useEffect(() => {
        if (steps.filtersDynamic) {
            if (items.current.all.length) {
                let groupsSelector = new CreateSelectorData();
                let zonesSelector = new CreateSelectorData();
                let islandsSelector = new CreateSelectorData();
                let routesSelector = new CreateSelectorData();
                items.current.all.forEach((item) => {
                    groupsSelector.add(item.asset.group_id, item.asset.group_name);
                    zonesSelector.add(item.asset.zone_id, item.asset.zone_name);
                    islandsSelector.add(item.asset.island_id, item.asset.island_name);
                    if (item.asset.routes_id) {
                        let routes_names = item.asset.routes_name.split(/,/);
                        item.asset.routes_id.split(/,/).forEach((id_, idx) => {
                            routesSelector.add(id_, routes_names[idx]);
                        })
                    }
                })
                setGroups(groupsSelector.get());
                setZones(zonesSelector.get());
                setIslands(islandsSelector.get());
                setRoutes(routesSelector.get());
            }
        } else {
            setGroups([]);
            setZones([]);
            setIslands([]);
            setRoutes([]);
            filters.current = {...FilterParams}
        }
    }, [steps.filtersDynamic]);

    const filterItems = () => {
        if (items.current.chosen.length) {
            items.current.chosen = [];
            setCheckedAll(false);
            setActiveMassive(false);
            setCounter("0/" + items.current.all.length);
            items.current.checkboxes.forEach(ele => {
                ele.checked = false;
            });
            items.current.checkboxes = [];
        }
        let _items = [...items.current.all];
        Object.keys(filters.current).some((key) => {
            if (!filters.current[key]) return false;
            switch (key) {
                case "searcher":
                    _items = _items.filter((item) => {
                        let words = toLowCaseCleanSpaces(item.asset.uid + "" + item.asset.full_address + "" + item.asset.uuids);
                        return words.includes(filters.current.searcher);
                    })
                    break;
                case "routes":
                    _items = _items.filter((item) => item.asset.routes_id.includes(filters.current[key]));
                    break;
                default:
                    _items = _items.filter((item) => item.asset[key + "_id"] === filters.current[key]);
            }
            return false;
        })
        items.current.showed = _items;
        setDynamicAssetsShow([...items.current.showed]);
    }

    const handleFilter = (e) => {
        let name = e.target.dataset.name;
        let value = e.target.value;

        if (value) {
            value = parseInt(value);
            filters.current[name] = value;
        } else {
            filters.current[name] = "";
        }
        filterItems();
    }
    const handleSearch = (e) => {
        if (e.target.value) {
            filters.current.searcher = toLowCaseCleanSpaces(e.target.value);
        } else {
            filters.current.searcher = "";
        }
        filterItems();
    }

    return (
        <>
            <div className="col mb-3" style={{maxWidth: "200px"}}>
                <label>Buscar</label>
                <div className="input-group mb-3">
                    <input type="search" className="form-control border-end-0"
                           placeholder="uid, uuid, dirección"
                           aria-label="uid, uuid, direción"
                           aria-describedby="dynamic-searcher-filter"
                           onChange={handleSearch}
                    />
                    <span className="input-group-text bg-transparent border-start-0 text-secondary"
                          id="dynamic-searcher-filter">
                        <FontAwesomeIcon icon="magnifying-glass"/>
                    </span>
                </div>
            </div>
            {
                groups.length
                    ? <div className="col mb-3" style={{maxWidth: "200px"}}>
                        <label>Grupos</label>
                        <select className="form-select" data-name="group" onChange={handleFilter}>
                            <option value="">Todos</option>
                            {
                                groups.map((item, index) => (
                                    <option key={index} value={item.id}>{item.name}</option>
                                ))
                            }
                        </select>
                    </div>
                    : <></>
            }
            {
                islands.length
                    ? <div className="col mb-3" style={{maxWidth: "200px"}}>
                        <label>Islas</label>
                        <select className="form-select" data-name="island" onChange={handleFilter}>
                            <option value="">Todas</option>
                            {
                                islands.map((item, index) => (
                                    <option key={index} value={item.id}>{item.name}</option>
                                ))
                            }
                        </select>
                    </div>
                    : <></>
            }
            {
                zones.length
                    ? <div className="col mb-3" style={{maxWidth: "200px"}}>
                        <label>Zonas</label>
                        <select className="form-select" data-name="zone" onChange={handleFilter}>
                            <option value="">Todas</option>
                            {
                                zones.map((item, index) => (
                                    <option key={index} value={item.id}>{item.name}</option>
                                ))
                            }
                        </select>
                    </div>
                    : <></>
            }
            {
                routes.length
                    ? <div className="col mb-3" style={{maxWidth: "200px"}}>
                        <label>Rutas</label>
                        <select className="form-select" data-name="routes" onChange={handleFilter}>
                            <option value="">Todos</option>
                            {
                                routes.map((item, index) => (
                                    <option key={index} value={item.id}>{item.name}</option>
                                ))
                            }
                        </select>
                    </div>
                    : <></>
            }
        </>
    )
}
export default TabCriteriaFilters;